@if (
  !(isSelectedPointEmpty$ | async) && (layoutService.isDesktopView$ | async)
  ) {
  <div
    >
    @if (!hidden) {
      <div class="icon-container">
        <button
          class="atlas-icon-button atlas-icon icon-street-view icon secondary-button"
          mat-flat-button
          aria-label="Street view"
          (click)="showImage()"
          [disabled]="areMultipleLocationsSelected$ | async"
        ></button>
      </div>
    }
    @if (hidden) {
      <div class="image-container">
        <div class="image">
          <img [src]="streetViewImageUrl" />
            <button class="left swipe" (click)="swipeLeft()">
              <mat-icon>chevron_left</mat-icon>
            </button>
            <button class="right swipe" (click)="swipeRight()">
              <mat-icon>chevron_right</mat-icon>
            </button>
          </div>
          <mat-icon class="image-close" (click)="hideImage()">close</mat-icon>
          <span class="image-number">{{ imageNumber }}/4</span>
          <button
            class="google-maps secondary-button"
            (click)="onStreetViewClicked()"
            i18n="@@exploreInGoogleMaps"
            >
      Explore in Google Maps
    </button>
        </div>
      }
    </div>
  }
